var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2618 19.376V19.3766C35.2617 19.9838 34.9963 20.5661 34.5238 20.9953C34.0514 21.4246 33.4106 21.6658 32.7426 21.6657C32.0745 21.6657 31.4338 21.4245 30.9614 20.9951C30.4891 20.5658 30.2237 19.9835 30.2237 19.3763C30.2237 18.7691 30.4891 18.1868 30.9614 17.7575C31.4338 17.3282 32.0745 17.0869 32.7426 17.0869C33.4106 17.0868 34.0514 17.328 34.5238 17.7573C34.9963 18.1866 35.2617 18.7688 35.2618 19.376ZM48.6947 10.9827V38.4516C48.6937 39.2608 48.3396 40.0366 47.71 40.6088C47.0804 41.181 46.2268 41.5028 45.3365 41.5037H8.39539C7.50503 41.5028 6.65143 41.181 6.02185 40.6088C5.39227 40.0366 5.03813 39.2608 5.03711 38.4516V10.9827C5.03813 10.1735 5.39227 9.39769 6.02185 8.82551C6.65143 8.25333 7.50503 7.93147 8.39539 7.93054H45.3365C46.2268 7.93147 47.0804 8.25333 47.71 8.82551C48.3396 9.39769 48.6937 10.1735 48.6947 10.9827ZM45.3382 31.7167L45.3365 10.9827H8.39539V28.6631L16.0956 21.6651C16.7259 21.0935 17.58 20.7726 18.4703 20.7726C19.3607 20.7726 20.2147 21.0935 20.845 21.6651L30.2244 30.1894L34.5661 26.2432C35.1965 25.6717 36.0505 25.3507 36.9409 25.3507C37.8312 25.3507 38.6853 25.6717 39.3156 26.2432L45.3382 31.7167Z",
    fill: "#476EF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemSingle);
export default __webpack_public_path__ + "static/media/itemSingle.e38cddb5b6006a80e06ecf3dde39f550.svg";
export { ForwardRef as ReactComponent };